import s from './PricingItem.module.scss';

function formatCurrency(price, currency = 'USD') {
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency,
  }).format(price);
}

export default function PricingItem({ heading, config }) {
  const pricingItems = config.filter((item) => item.price);

  if (!pricingItems.length) return null;

  return (
    <div className={s.wrapper}>
      <Item heading={heading}>
        {pricingItems.map((item, index) => (
          <SubItem
            key={index}
            price={item.price}
            currency={item.currency}
            description={item.description}
          />
        ))}
      </Item>
    </div>
  );
}

function Item({ heading, children }) {
  return (
    <div className={s.itemWrapper}>
      <span className={s.itemHeading}>{heading}</span>
      <span>{children}</span>
    </div>
  );
}

function SubItem({ price, description }) {
  const formattedPrice = Array.isArray(price)
    ? price.map((priceItem) => formatCurrency(priceItem)).join(` - `)
    : formatCurrency(price);

  return (
    <span>
      <span>{formattedPrice}</span>
      {description && <span> — </span>}
      <span>{description}</span>
      <br />
    </span>
  );
}
